import { render, staticRenderFns } from "./BedroomsDropdown.vue?vue&type=template&id=2d733d61&scoped=true&"
import script from "./BedroomsDropdown.vue?vue&type=script&lang=js&"
export * from "./BedroomsDropdown.vue?vue&type=script&lang=js&"
import style0 from "./BedroomsDropdown.vue?vue&type=style&index=0&id=2d733d61&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d733d61",
  null
  
)

export default component.exports